import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/location"

export const getSystemLocations = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getSystemLocation = async locationId => {
  const response = await farasod.get(`${endpoint}/${locationId}`)

  return response.data
}

export const addSystemLocation = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editSystemLocation = async (locationId, data) => {
  const response = await farasod.patch(`${endpoint}/${locationId}`, data)

  return response.data
}

export const deleteSystemLocation = async locationId => {
  const response = await farasod.delete(`${endpoint}/${locationId}`)

  return response.data
}